import { useContext, useEffect, useState } from 'react'
import PageContext from '../../global_state/context/PageContext'
import SCSS from 'assets/scss/Lessons.module.scss'
import SCSSForm from 'assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'

import Loader from 'components/Loader'
import Title from 'components/Title'
import { Lesson } from 'types/Lesson'
import { getLessons, lessonCreateReservation, getFilters } from 'services/LessonsServices'
import content from 'languages/Lessons.json'
import { PageType } from 'types/PageI'
import LessonElement from 'components/lessons/LessonElement'
import UserState from 'global_state/state/UserState'



function Lessons() {

    const { page, dispatchPage } = useContext(PageContext)
    let lang = page.settings.language

    const [lessons, setLessons] = useState({})
    const [lessons_batch, setLessonsBatch] = useState({page: 0, lessons: []})

    const [initLoading, setInitLoading] = useState(true)
    const [loading, setLoading] = useState(true)
    const [all_loaded, setAllLoaded] = useState(false)

    const [instructors_filters, setInstructorsFilters] = useState<Array<{ ID: number, NAME: string }>>([{ ID: -1, NAME: content[lang].filter.all }])
    const [lessons_filters, setLessonsFilters] = useState<Array< { NAME: string, KEYS: any[], LECTORS: any[] }>>([{NAME: content[lang].filter.all, KEYS: [], LECTORS: []}])

    const [useFilter, setUseFilter] = useState(false)
    const [selectedFilterDate, setSelectedFilterDate] = useState(new Date())
    const [selectedFilterInstructor, setSelectedFilterInstructor] = useState<number>(-1)
    const [selectedFilterLesson, setSelectedFilterLesson] = useState<number>(-1)
    
    
    

    
    const getLastLoadedLessonsPage = () => {
        let lastKey = parseInt(Object.keys(lessons).pop() || "-1")

        if (initLoading) {
            lastKey = -1
        }

        let key = lastKey + 1 

        return key
    }
    const getLoadedLessonsBatch = async () => {
        let loaded_lessons = await getLessons(
            getLastLoadedLessonsPage(),
            selectedFilterDate,
            selectedFilterInstructor,
            selectedFilterLesson
        
        )
        
        // console.log("Loaded lessons:", loaded_lessons);
        setLessonsBatch(loaded_lessons)
    }
    const getLessonsFilters = async () => {
        let filters = await getFilters()
        // console.log("Filters:", filters);
        if (Array.isArray(filters.instructors)){
            filters.instructors.forEach((instructor) => {
                setInstructorsFilters(data => {
                    let included = false

                    data.forEach(d => {
                        if (d.ID == instructor.ID) {
                            included = true
                        }
                    })

                    if (included) {
                        return data
                    }

                    return [...data, instructor]
                })
            })    
        }
        
        if (Array.isArray(filters.lessons)) {
            filters.lessons.forEach((lesson) => {
                setLessonsFilters(data => {
                    let included = false
                    data.forEach(d => {
                        if (d.NAME == lesson.NAME) {
                            included = true
                        }
                    })

                    if (included) {
                        return data
                    }

                    return [...data, lesson]
                })
            })
        }
            
    }

    useEffect(() => {
        // console.log("On Load");
        getLessonsFilters()
    }, [])
    useEffect(() => {
        // console.log("Lessons Batch", lessons_batch);
        
        if (lessons_batch === undefined) {
            return
        }

        if (typeof lessons_batch.lessons === "string") {
            setAllLoaded(true)
            setLoading(false)
            setInitLoading(false)
            return
        }

        setLessons((state) => {
            let new_lessons = state
            // console.log("State", state);
            
            new_lessons[lessons_batch.page] = lessons_batch.lessons
            // console.log("New Lessons", new_lessons);
                 
            setLoading(false)
            setInitLoading(false)
            return new_lessons
        })
    }, [lessons_batch])
    
    useEffect(() => {
        // console.log("Lessons:", lessons);
        if (Object.keys(lessons).length === 0 ) {
            setInitLoading(true)
        }
    }, [lessons])

    useEffect(() => {
        if (loading) {
            // console.log("Loading");
            getLoadedLessonsBatch()
        }
    }, [loading])


    useEffect(() => {
        
        // console.log("selectedFilterDate:", selectedFilterDate);
        // console.log("selectedFilterInstructor:", selectedFilterInstructor);
        // console.log("selectedFilterLesson:", selectedFilterLesson);
        
        
        setLessons({})
        setLoading(true)
        // setLoading(true)



    }, [selectedFilterDate, selectedFilterInstructor, selectedFilterLesson])
    
    const lazyLoading = () => {
        if (loading) {
            return 
        }
        setLoading(true)

        // if (!loading) {
        //     // console.log("set lazy loading");
        // }
        
        // const {
        //     scrollTop,
        //     scrollHeight,
        //     clientHeight
        // } = document.documentElement;

        // if (scrollTop + clientHeight >= scrollHeight - 200) {
        //     setLoading(true)
        //     getLoadedLessonsBatch()
        // // }
        // setLoading(true)
        // getLoadedLessonsBatch()
    }


    // const loadLessons = async (initalLoad: boolean = false, scrollTop: number = 0) => {
    //     if (initalLoad && page_number > 0)
    //         return;
    //     if (loading)
    //         return;

    //     // console.log("TOP: " + scrollTop);

    //     setLoading(true)
    //     // loading = true
    //     page_number += 1
    //     let loadedLessons = await getLessons(page_number, selectedDate, selectedInstructor, selectedLessonFilter);

    //     if (Array.isArray(loadedLessons)) {

    //         loadedLessons.filter(async l => {
    //             let in_array_lessons = (
    //                 await Promise.resolve(
    //                     await lessons.filter(async e => e.id == l.id)
    //                 )).values

    //                 if (in_array_lessons.length == 0) {
    //                 setLessons(data => {
    //                     return [...data, l]
    //                 })
    //             }
    //         })

    //         if (loadedLessons.length == 0) {
    //             setAllLoaded(true);
    //         }
    //     }

    //     window.scrollTo(0, scrollTop)
    //     setTimeout(() => {setLoading(false)}, 1500);

    // }

    // const lazyLoad = () => {
    //     // console.log("lazyLoad: " + loading);

    //     if (loading == true) {
    //         return 
    //     }

    //     const {
    //         scrollTop,
    //         scrollHeight,
    //         clientHeight
    //     } = document.documentElement;

    //     // console.log(scrollTop, scrollHeight, clientHeight);


    //     if (scrollTop + clientHeight >= scrollHeight - 5 && !allLoaded) {
    //         loadLessons(false, scrollTop);
    //     }
    // }

    // useEffect(() => {
    //     document.addEventListener("scroll", lazyLoad, true);
    //     lessonFilters().then(data => {
    
    //         if (instructors.length > 1)
    //             return;
    
    //         if (Array.isArray(data.instructors))
    //             data.instructors.forEach(instructor => {

    //                 setInstructors(data => {
    //                     let included = false

    //                     data.forEach(d => {
    //                         if (d.ID == instructor.ID) {
    //                             included = true
    //                         }
    //                     })

    //                     if (included) {
    //                         return data
    //                     }

    //                     return [...data, instructor]
    //                 })

    //             });
    
    //         if (Array.isArray(data.lessons))
    //             data.lessons.forEach(lesson => {
    //                 // console.log(lesson);


    //             setLessonsFilters(data => {
    //                 let included = false
    //                 data.forEach(d => {
    //                     if (d.NAME == lesson.NAME) {
    //                         included = true
    //                     }
    //                 })

    //                 if (included) {
    //                     return data
    //                 }

    //                 return [...data, lesson]
    //             })



    //             });

    //     })
    //     return () => {
    //         document.removeEventListener("scroll", lazyLoad, true);
    //     }
    // }, [])

    // useEffect(() => {
    //     page_number = 0;
    //     setLessons(data => []);

    //     const {scrollTop} = document.documentElement;
    //     loadLessons(true,scrollTop);

    // }, [selectedDate, selectedInstructor, selectedLessonFilter])


    const changeDate = (value) => {
        let set = value ? new Date(value) : new Date();
        // console.log("Change Date Value", set);
        setSelectedFilterDate(set);
    }

    const changeCoach = (value) => {
        setSelectedFilterInstructor(value);
    }

    const changeLessonFilter = (value) => {
        setSelectedFilterLesson(value);
    }

    const inputDateValue = (value: Date) => {
        let month: string | number = value.getUTCMonth() + 1;
        if (month < 10)
            month = "0" + month;
        let day: string | number = value.getUTCDate();
        if (day < 10)
            day = "0" + day;
        return value.getFullYear() + "-" + month + "-" + day;
    }

    const renderLectorsOptions = () => {
        if (selectedFilterLesson == -1 ) {
            return (
                instructors_filters.map((coach, index) => {
                    return (<option key={index} value={coach.ID}>{coach.NAME}</option>)
                })
            )
        }

        if (typeof selectedFilterLesson == 'string') {
            let filtered_lessons: any[] = lessons_filters.filter((l, i , a) => l.NAME == selectedFilterLesson)
            // console.log(filtered_lessons);
            // {NAME: "Vše", KEYS: [], LECTORS: []}
            return (

                instructors_filters.map((coach, index) => {


                    let include_coach = false

                    if (coach.ID == -1) {
                        return (<option key={index} value={coach.ID}>{coach.NAME}</option>)
                    }

                    filtered_lessons.forEach((l) => {                        
                        if (l.LECTORS.includes(coach.ID.toString())) {
                            include_coach = true
                        }
                    })
                    if (include_coach) {
                        return (<option key={index} value={coach.ID}>{coach.NAME}</option>)
                    }

                })

            )    
        }
    }

    const renderLessonsOptions = () => {
        if (selectedFilterInstructor == -1) {
            return (
                lessons_filters.map((lesson, index) => {
                    return <option key={index} value={index == 0 ? -1 : lesson.NAME}>{lesson.NAME}</option>
                })
            )
        }

        if (selectedFilterInstructor != -1) {
            return (
                lessons_filters.map((lesson, index) => {
                    if (lesson.NAME == content[lang].filter.all) {
                        return <option key={index} value={index == 0 ? -1 : lesson.NAME}>{lesson.NAME}</option>
                    }
                    if (lesson.LECTORS.includes(selectedFilterInstructor.toString())) {
                        return <option key={index} value={index == 0 ? -1 : lesson.NAME}>{lesson.NAME}</option>
                    }  
                })
            )
        }

    }

    const renderFilters = () => {
        return (
            <div className={SCSS.filters}>
                <table>
                    <tbody>
                        <tr>
                            <th>{content[lang].filter.from_when}</th>
                            <td>
                                <input 
                                    className={SCSSForm.input} 
                                    type="date" 
                                    value={inputDateValue(selectedFilterDate)} 
                                    min={inputDateValue(new Date())} 
                                    onChange={e => changeDate(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <th>{content[lang].filter.lector}</th>
                            <td>
                                <select 
                                    className={SCSSForm.select} 
                                    defaultValue={selectedFilterInstructor} 
                                    onChange={e => changeCoach(e.target.value)}>
                                    { renderLectorsOptions()}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>{content[lang].filter.lesson}</th>
                            <td>
                                <select 
                                    className={SCSSForm.select} 
                                    defaultValue={selectedFilterLesson} 
                                    onChange={e => changeLessonFilter(e.target.value)}>
                                    {renderLessonsOptions()}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        )
    }

    const renderMoreButton = () => {
        if (all_loaded) {
            return 
        }
        return (
            <div style={{ textAlign: "center" }}>
                <button
                    onClick={() => {
                        lazyLoading()
                    }}
                    className={[AppSCSS.button, AppSCSS.red].join(" ")} type="button">
                    {content[lang].load_more_button}
                </button>
            </div>
        )
    }

    const setRenderDate = (date) => {
        let year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        let day = date.getUTCDate()

        return [day, month, year].join(".")
    }
    const renderLessons = () => {
        // console.log("Init Loading", initLoading);
        
        let render_date: null|string = null
        // console.log("renderLessons", lessons);
        // console.log(parseInt(Object.keys(lessons).pop() || "0"));
        
        
        let render_lessons: any[] = []
        let last_key = parseInt(Object.keys(lessons).pop() || "0")
        for (let i = 0; i <= last_key; i++) {
            // console.log("renderLessons", i, lessons);

            if (lessons === undefined || lessons[i] === undefined) {
                continue 
            } 

            let render_lessons_batch = lessons[i].map((l, n) => {
                let date = setRenderDate(l.date)
                let lesson_element = <LessonElement key={"lesson_" + i + n } lesson={l} language={lang} />

                if (render_date != date) {
                    render_date = date
                    return [
                        <div key={render_date} className={SCSS.lesson_wrapper}><h2>{render_date}</h2></div>, 
                        lesson_element
                    ] 
                }

                return (lesson_element)
            })        

            // console.log("renderLessons", i, render_lessons_batch);

            if (render_lessons.length === 0) {
                render_lessons.push(...render_lessons_batch)
            } 
            else {
                render_lessons = render_lessons.concat(...render_lessons_batch)
            }
            
            
        }
        return render_lessons
        // console.log("renderLessons", render_lessons);
        // return render_lessons.map(lesson => {return lesson})
    }

    const renderLoading = () => {
        if (loading) {
            return <Loader />
        }
    }
    const renderContent = () => {
        return (
            <div>
                {renderLessons()}
                {renderLoading()}
                {renderMoreButton()}
            </div>
        )
    }
    return (
        <div className={SCSS.lessons}>
            <Title back_arrow={true} page={PageType.reservations} title={content[lang].title} />
            {renderFilters()}
            {renderContent()}
        </div>
    )
}


// new inputs format - stall for now
// function Filters(props: any) {
//     return (
//         <div className={SCSS.filters}>
//             <Filter name={FilterNames.date} />
//             <Filter name={FilterNames.lector} instructors={props.instructors}/>
//             <Filter name={FilterNames.lesson} lessons={props.lessons}/>
//         </div>
//     )
// }
// enum FilterNames {
//     "date" = "date",
//     "lector" = "lector",
//     "lesson" = "lesson"
// }

// function Filter(props: any) {
//     // console.log(props);

//     const convertDateToString = (date:Date) => {        
//         let year: string | number = date.getUTCFullYear()
//         let month: string  = ("0" + (date.getUTCMonth() + 1)).slice(-2);
//         let day: string  = ("0" + date.getUTCDate()).slice(-2)

//         return [year, month, day].join("-")
//     }

//     const [filter_date_value, setFilterDateValue] = useState(convertDateToString(new Date()))

//     let content = {
//         "CZ": {
//             "filter_date_label": "Od Kdy:",
//             "filter_lectors_label" : "Lektor:"
//         },
//         "EN": {
//             "filter_date_label": "From:",
//             "filter_lectors_label": "Lector:"
//         }
//     }

//     const { page, dispatchPage } = useContext(PageContext)
//     let lang = page.settings.language

//     const renderFilterLabel = () => {
//         switch (props.name) {
//             case (FilterNames.date): {
//                 return content[lang].filter_date_label
//                 break;
//             }
//             case (FilterNames.lector): {
//                 return content[lang].filter_lectors_label
//                 break;
//             }
//             case (FilterNames.lesson): {
//                 break;
//             }
//             default:
//                 return null
//                 break;
//         }
//     }


//     const renderFilterInput = () => {
//         switch (props.name) {
//             case (FilterNames.date): {
//                 return (
//                     <input
//                         id={FilterNames.date}
//                         name={FilterNames.date}
//                         className={SCSSForm.input}
//                         type="date"
//                         value={filter_date_value}
//                         min={convertDateToString(new Date())}
//                         onChange={(e) => setFilterDateValue(convertDateToString(new Date(e.target.value)))}
//                     ></input>
//                 )
//                 break;
//             }
//             case (FilterNames.lector): {
//                 return (
//                     <>
//                         <input
//                             className={SCSSForm.input}
//                             id={FilterNames.lector}
//                             name={FilterNames.lector}
//                             onFocus={(e) => {
//                                 console.log("open select");

//                             }}
//                             >
//                         </input>
//                         <div className={SCSS.icon}><BiChevronDown/></div>
//                         <div className={SCSS.data_list}>
//                             <span>one</span>
//                             <span>two</span>
//                             <span>three</span>
//                         </div>
//                     </>
//                 )
//                 break;
//             }
//             case (FilterNames.lesson): {
//                 break;
//             }
//             default:
//                 return null
//                 break;
//         }

//     }
//     return (
//         <div className={SCSS.filter_row}>
//             {/* {props.name} */}
//             <div className={SCSS.filter_label}>
//                 {renderFilterLabel()}
//             </div>
//             <div className={SCSS.filter_input}>
//                 {renderFilterInput()}
//             </div>
//         </div>
//     )
// }

export default Lessons